import React from 'react';
import { Tooltip } from 'reactstrap';

const ZipCodePattern = /^\d{5}$/;

export default class ZipCode extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput : false
        };
    }

    componentDidMount() {
        const { setFocus, zipCode } = this.props;
        if (setFocus) {
            const input = document.getElementById(zipCode);
            if (input) {
                input.focus();
            }
        }
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    isNumericInput = (event) => {
        const key = event.keyCode;
        return ((key >= 48 && key <= 57) || // Allow number line
            (key >= 96 && key <= 105) // Allow number pad
        );
    };
    
    isModifierKey = (event) => {
        const key = event.keyCode;
        return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
            (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
            (key > 36 && key < 41) || // Allow left, up, right, down
            (
                (event.ctrlKey === true || event.metaKey === true) &&
                (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
            )
    };

    onKeyPress = (event) => {
        if(!this.isNumericInput(event) && !this.isModifierKey(event)){
            event.preventDefault();
        }
    };

    onKeyUp = (event) => {         
        if(!this.isNumericInput(event) && !this.isModifierKey(event)){
            event.preventDefault();
        }
        if(event.target.value){
            this.setState({ invalidInput: false });
        }   
        
    }

    onChange(event) {
        this.props.onChange(event, this.isValid(event.target.value));
    }

    isValid(value) {       
        return value.trim() && ZipCodePattern.test(value);
    }

    clearInput(event) {       
        const e = { event, target: { value: "", name: this.props.name ? this.props.name : ""} };
        this.onChange(e);        
    }

      validateOnBlur(event){   
        this.props.onChange(event, this.isValid(event.target.value));
        if(this.props.required){
          event.persist();      
          if(event.target.value){  
            var validPattern= ZipCodePattern.test(event.target.value);
              if(validPattern){      
               this.setState({invalidInput:false});
              }
              else{
               this.setState({invalidInput:true});
              }
          }
          else{
            this.setState({invalidInput:true});
          }
        }   
       
    }
    
    render() {
        const { placeholder, value, zipCode, required, name, id, autoFocus, disabled, inputErrorMsg, tooltipID, tooltipMsg, showAsInvalid, autoComplete, showClearBtn } = this.props;
        const containerClassName = (value ? " input-not-empty" : "") + (this.state.invalidInput || showAsInvalid ? " input-invalid" : "") + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={"il-group" + containerClassName}>
                <input type="text" id={zipCode}
                    className="form-control"
                    value={ value }
                    required = { required }
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : "Zip Code"} maxLength={5}
                    onKeyUp={e => this.onKeyUp(e)} onKeyDown={e => this.onKeyPress(e)}
                    onChange={e => this.onChange(e)}
                    onBlur={this.validateOnBlur}
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out the Zip Code."}
                    aria-label={placeholder ? placeholder : 'Zip Code'}
                    autoComplete={autoComplete}
                />
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleTooltip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                {showClearBtn && value && <span className="clear-btn" aria-label="clear button" onClick={this.clearInput}><span className="icon-input-clear" /></span>}
                <div className="il-label">{placeholder}</div>
                {((typeof value !== "undefined" && value) || inputErrorMsg) && <div className="input-error-msg">{inputErrorMsg ? inputErrorMsg :"Please enter a 5 digit zip code."}</div>}
            </div>    
        );
    }
}